/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetFactoriesByGroupID,
    GetOutletOrderDetails,
    GetAllConfigarationValues,
    GetApprovedProductPrice,
    SaveGenerateOrder,
    GetPerformOrderDetailsForMainOrder,
    UpdatePerformOrder,
    GetAllProductsDetails
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetOutletOrderDetails(date) {
    const response = await CommonGet('/api/OutletOrder/GetOutletOrdersDetails', 'date=' + date);
    return response.data;
}

async function GetAllConfigarationValues(groupID, operationEntityID) {
    const response = await CommonGet('/api/Configuration/GetAllConfigarationValues', 'groupID=' + parseInt(groupID) + '&operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetApprovedProductPrice(date) {
    const response = await CommonGet('/api/ProductPrice/GetApprovedProductPriceByDate', 'date=' + date);
    return response.data;
}

async function SaveGenerateOrder(data) {
    const response = await CommonPost('/api/OutletOrder/SaveGenerateOrderPerform', null, data);
    return response;
}

async function GetPerformOrderDetailsForMainOrder(date) {
    const response = await CommonGet('/api/OutletOrder/GetPerformOrderDetailsForMainOrder', 'date=' + date);
    return response.data;
}

async function UpdatePerformOrder(data) {
    const response = await CommonPost('/api/OutletOrder/UpdatePerformOrder', null, data);
    return response;
}

async function GetAllProductsDetails() {
    const response = await CommonGet('/api/Product/GetAllProductsDetails', null);
    return response.data;
}